/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/AgentClass
 */
var AgentClass = 'http://purl.org/dc/terms/AgentClass';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/BibliographicResource
 */
var BibliographicResource = 'http://purl.org/dc/terms/BibliographicResource';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Box
 */
var Box = 'http://purl.org/dc/terms/Box';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/FileFormat
 */
var FileFormat = 'http://purl.org/dc/terms/FileFormat';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Frequency
 */
var Frequency = 'http://purl.org/dc/terms/Frequency';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/ISO3166
 */
var ISO3166 = 'http://purl.org/dc/terms/ISO3166';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Jurisdiction
 */
var Jurisdiction = 'http://purl.org/dc/terms/Jurisdiction';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/LicenseDocument
 */
var LicenseDocument = 'http://purl.org/dc/terms/LicenseDocument';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/LinguisticSystem
 */
var LinguisticSystem = 'http://purl.org/dc/terms/LinguisticSystem';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Location
 */
var Location = 'http://purl.org/dc/terms/Location';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/LocationPeriodOrJurisdiction
 */
var LocationPeriodOrJurisdiction = 'http://purl.org/dc/terms/LocationPeriodOrJurisdiction';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/MediaType
 */
var MediaType = 'http://purl.org/dc/terms/MediaType';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/MediaTypeOrExtent
 */
var MediaTypeOrExtent = 'http://purl.org/dc/terms/MediaTypeOrExtent';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/MethodOfAccrual
 */
var MethodOfAccrual = 'http://purl.org/dc/terms/MethodOfAccrual';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/MethodOfInstruction
 */
var MethodOfInstruction = 'http://purl.org/dc/terms/MethodOfInstruction';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Period
 */
var Period = 'http://purl.org/dc/terms/Period';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/PeriodOfTime
 */
var PeriodOfTime = 'http://purl.org/dc/terms/PeriodOfTime';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/PhysicalMedium
 */
var PhysicalMedium = 'http://purl.org/dc/terms/PhysicalMedium';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/PhysicalResource
 */
var PhysicalResource = 'http://purl.org/dc/terms/PhysicalResource';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Point
 */
var Point = 'http://purl.org/dc/terms/Point';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Policy
 */
var Policy = 'http://purl.org/dc/terms/Policy';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/ProvenanceStatement
 */
var ProvenanceStatement = 'http://purl.org/dc/terms/ProvenanceStatement';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/RFC1766
 */
var RFC1766 = 'http://purl.org/dc/terms/RFC1766';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/RFC3066
 */
var RFC3066 = 'http://purl.org/dc/terms/RFC3066';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/RFC4646
 */
var RFC4646 = 'http://purl.org/dc/terms/RFC4646';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/RFC5646
 */
var RFC5646 = 'http://purl.org/dc/terms/RFC5646';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/RightsStatement
 */
var RightsStatement = 'http://purl.org/dc/terms/RightsStatement';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/SizeOrDuration
 */
var SizeOrDuration = 'http://purl.org/dc/terms/SizeOrDuration';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/Standard
 */
var Standard = 'http://purl.org/dc/terms/Standard';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/URI
 */
var URI = 'http://purl.org/dc/terms/URI';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/W3CDTF
 */
var W3CDTF = 'http://purl.org/dc/terms/W3CDTF';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/abstract
 */
var abstract = 'http://purl.org/dc/terms/abstract';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/accessRights
 */
var accessRights = 'http://purl.org/dc/terms/accessRights';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/accrualMethod
 */
var accrualMethod = 'http://purl.org/dc/terms/accrualMethod';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/accrualPeriodicity
 */
var accrualPeriodicity = 'http://purl.org/dc/terms/accrualPeriodicity';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/accrualPolicy
 */
var accrualPolicy = 'http://purl.org/dc/terms/accrualPolicy';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/alternative
 */
var alternative = 'http://purl.org/dc/terms/alternative';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/audience
 */
var audience = 'http://purl.org/dc/terms/audience';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/available
 */
var available = 'http://purl.org/dc/terms/available';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/bibliographicCitation
 */
var bibliographicCitation = 'http://purl.org/dc/terms/bibliographicCitation';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/conformsTo
 */
var conformsTo = 'http://purl.org/dc/terms/conformsTo';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/contributor
 */
var contributor = 'http://purl.org/dc/terms/contributor';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/coverage
 */
var coverage = 'http://purl.org/dc/terms/coverage';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/created
 */
var created = 'http://purl.org/dc/terms/created';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/creator
 */
var creator = 'http://purl.org/dc/terms/creator';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/date
 */
var date = 'http://purl.org/dc/terms/date';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/dateAccepted
 */
var dateAccepted = 'http://purl.org/dc/terms/dateAccepted';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/dateCopyrighted
 */
var dateCopyrighted = 'http://purl.org/dc/terms/dateCopyrighted';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/dateSubmitted
 */
var dateSubmitted = 'http://purl.org/dc/terms/dateSubmitted';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/description
 */
var description = 'http://purl.org/dc/terms/description';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/educationLevel
 */
var educationLevel = 'http://purl.org/dc/terms/educationLevel';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/extent
 */
var extent = 'http://purl.org/dc/terms/extent';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/format
 */
var format = 'http://purl.org/dc/terms/format';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/hasFormat
 */
var hasFormat = 'http://purl.org/dc/terms/hasFormat';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/hasPart
 */
var hasPart = 'http://purl.org/dc/terms/hasPart';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/hasVersion
 */
var hasVersion = 'http://purl.org/dc/terms/hasVersion';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/identifier
 */
var identifier = 'http://purl.org/dc/terms/identifier';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/instructionalMethod
 */
var instructionalMethod = 'http://purl.org/dc/terms/instructionalMethod';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/isFormatOf
 */
var isFormatOf = 'http://purl.org/dc/terms/isFormatOf';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/isPartOf
 */
var isPartOf = 'http://purl.org/dc/terms/isPartOf';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/isReferencedBy
 */
var isReferencedBy = 'http://purl.org/dc/terms/isReferencedBy';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/isReplacedBy
 */
var isReplacedBy = 'http://purl.org/dc/terms/isReplacedBy';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/isRequiredBy
 */
var isRequiredBy = 'http://purl.org/dc/terms/isRequiredBy';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/isVersionOf
 */
var isVersionOf = 'http://purl.org/dc/terms/isVersionOf';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/issued
 */
var issued = 'http://purl.org/dc/terms/issued';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/language
 */
var language = 'http://purl.org/dc/terms/language';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/license
 */
var license = 'http://purl.org/dc/terms/license';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/mediator
 */
var mediator = 'http://purl.org/dc/terms/mediator';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/medium
 */
var medium = 'http://purl.org/dc/terms/medium';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/modified
 */
var modified = 'http://purl.org/dc/terms/modified';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/provenance
 */
var provenance = 'http://purl.org/dc/terms/provenance';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/publisher
 */
var publisher = 'http://purl.org/dc/terms/publisher';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/references
 */
var references = 'http://purl.org/dc/terms/references';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/relation
 */
var relation = 'http://purl.org/dc/terms/relation';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/replaces
 */
var replaces = 'http://purl.org/dc/terms/replaces';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/requires
 */
var requires = 'http://purl.org/dc/terms/requires';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/rights
 */
var rights = 'http://purl.org/dc/terms/rights';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/rightsHolder
 */
var rightsHolder = 'http://purl.org/dc/terms/rightsHolder';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/source
 */
var source = 'http://purl.org/dc/terms/source';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/spatial
 */
var spatial = 'http://purl.org/dc/terms/spatial';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/subject
 */
var subject = 'http://purl.org/dc/terms/subject';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/tableOfContents
 */
var tableOfContents = 'http://purl.org/dc/terms/tableOfContents';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/temporal
 */
var temporal = 'http://purl.org/dc/terms/temporal';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/title
 */
var title = 'http://purl.org/dc/terms/title';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/type
 */
var type = 'http://purl.org/dc/terms/type';
/**
 *
 *
 *
 *
 * http://purl.org/dc/terms/valid
 */
var valid = 'http://purl.org/dc/terms/valid';

var dctImport = /*#__PURE__*/Object.freeze({
	AgentClass: AgentClass,
	BibliographicResource: BibliographicResource,
	Box: Box,
	FileFormat: FileFormat,
	Frequency: Frequency,
	ISO3166: ISO3166,
	Jurisdiction: Jurisdiction,
	LicenseDocument: LicenseDocument,
	LinguisticSystem: LinguisticSystem,
	Location: Location,
	LocationPeriodOrJurisdiction: LocationPeriodOrJurisdiction,
	MediaType: MediaType,
	MediaTypeOrExtent: MediaTypeOrExtent,
	MethodOfAccrual: MethodOfAccrual,
	MethodOfInstruction: MethodOfInstruction,
	Period: Period,
	PeriodOfTime: PeriodOfTime,
	PhysicalMedium: PhysicalMedium,
	PhysicalResource: PhysicalResource,
	Point: Point,
	Policy: Policy,
	ProvenanceStatement: ProvenanceStatement,
	RFC1766: RFC1766,
	RFC3066: RFC3066,
	RFC4646: RFC4646,
	RFC5646: RFC5646,
	RightsStatement: RightsStatement,
	SizeOrDuration: SizeOrDuration,
	Standard: Standard,
	URI: URI,
	W3CDTF: W3CDTF,
	abstract: abstract,
	accessRights: accessRights,
	accrualMethod: accrualMethod,
	accrualPeriodicity: accrualPeriodicity,
	accrualPolicy: accrualPolicy,
	alternative: alternative,
	audience: audience,
	available: available,
	bibliographicCitation: bibliographicCitation,
	conformsTo: conformsTo,
	contributor: contributor,
	coverage: coverage,
	created: created,
	creator: creator,
	date: date,
	dateAccepted: dateAccepted,
	dateCopyrighted: dateCopyrighted,
	dateSubmitted: dateSubmitted,
	description: description,
	educationLevel: educationLevel,
	extent: extent,
	format: format,
	hasFormat: hasFormat,
	hasPart: hasPart,
	hasVersion: hasVersion,
	identifier: identifier,
	instructionalMethod: instructionalMethod,
	isFormatOf: isFormatOf,
	isPartOf: isPartOf,
	isReferencedBy: isReferencedBy,
	isReplacedBy: isReplacedBy,
	isRequiredBy: isRequiredBy,
	isVersionOf: isVersionOf,
	issued: issued,
	language: language,
	license: license,
	mediator: mediator,
	medium: medium,
	modified: modified,
	provenance: provenance,
	publisher: publisher,
	references: references,
	relation: relation,
	replaces: replaces,
	requires: requires,
	rights: rights,
	rightsHolder: rightsHolder,
	source: source,
	spatial: spatial,
	subject: subject,
	tableOfContents: tableOfContents,
	temporal: temporal,
	title: title,
	type: type,
	valid: valid
});

export { hasFormat as $, AgentClass as A, BibliographicResource as B, available as C, bibliographicCitation as D, conformsTo as E, FileFormat as F, contributor as G, coverage as H, ISO3166 as I, Jurisdiction as J, created as K, LicenseDocument as L, MediaType as M, creator as N, date as O, Period as P, dateAccepted as Q, RFC1766 as R, SizeOrDuration as S, dateCopyrighted as T, URI as U, dateSubmitted as V, W3CDTF as W, description as X, educationLevel as Y, extent as Z, format as _, Box as a, hasPart as a0, hasVersion as a1, identifier as a2, instructionalMethod as a3, isFormatOf as a4, isPartOf as a5, isReferencedBy as a6, isReplacedBy as a7, isRequiredBy as a8, isVersionOf as a9, issued as aa, language as ab, license as ac, mediator as ad, medium as ae, modified as af, provenance as ag, publisher as ah, references as ai, relation as aj, replaces as ak, requires as al, rights as am, rightsHolder as an, source as ao, spatial as ap, subject as aq, tableOfContents as ar, temporal as as, title as at, type as au, valid as av, dctImport as aw, Frequency as b, LinguisticSystem as c, Location as d, LocationPeriodOrJurisdiction as e, MediaTypeOrExtent as f, MethodOfAccrual as g, MethodOfInstruction as h, PeriodOfTime as i, PhysicalMedium as j, PhysicalResource as k, Point as l, Policy as m, ProvenanceStatement as n, RFC3066 as o, RFC4646 as p, RFC5646 as q, RightsStatement as r, Standard as s, abstract as t, accessRights as u, accrualMethod as v, accrualPeriodicity as w, accrualPolicy as x, alternative as y, audience as z };
